module.exports = window["wc"]["priceFormat"];